// extracted by mini-css-extract-plugin
export default {"button":"Button_button__2KIh4","disabled":"Button_disabled__OBLxY","bck":"Button_bck__QzUUT"};